export default __webpack_public_path__ + "images/JX.27741ef.png";